import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { toCamelCase } from '@huggg/bar-staff';
import { Body_4 as Body4 } from '@huggg/react-components';

import { BarCode, QRCode } from 'components/ui';
import AlphaText from './AlphaText';
import Pin4Resend from './Pin4Resend';
import Url from './Url';

import styles from './types.module.scss';
import PrepaidCard from './PrepaidCard/PrepaidCard';
import Alert from './Alert';

const VoucherTypes = props => {
  const { vouchers, redeemedSegment } = props;
  let urlValue = '';

  return (
    <>
      <div className={styles.vouchers}>
        {vouchers.map((item, index) => {
          const types = item.type.split('/');
          const typeClassName = toCamelCase('type/' + item.type);

          if (item.type === 'alpha/url') {
            urlValue = item.value;
          }

          return (
            <div
              className={classnames(styles.voucherType, styles[typeClassName])}
              key={index}
            >
              {item.type !== 'url' && item.label && (
                <Body4 className={styles.label}>{item.label}</Body4>
              )}

              {types[0] === 'qr' && (
                <QRCode
                  code={item.value}
                  imageClassName={styles.qrCodeImage}
                  data-test-id="voucher-image-qr"
                />
              )}

              {types[0] === 'barcode' && (
                <BarCode
                  code={item.value}
                  imageClassName={styles.barCodeImage}
                  data-test-id="voucher-image-barcode"
                />
              )}

              {types[0] === 'alpha' && <AlphaText data={item} />}

              {item.type === 'pin4/resend' && <Pin4Resend data={item} />}

              {types[0] === 'url' && <Url data={item} value={urlValue} />}

              {item.type === 'prepaid-card/id' && (<PrepaidCard id={item.value} segment={redeemedSegment} />)}

              {types[0] === 'alert' && (<Alert value={{ level: types[1], message: item.value }} />)}
            </div>
          );
        })}
      </div>
    </>
  );
};

VoucherTypes.propTypes = {
  brandName: PropTypes.string.isRequired,
  huggg: PropTypes.object.isRequired,
  children: PropTypes.node,
  vouchers: PropTypes.array,
  redeemedSegment: PropTypes.object,
};

export default VoucherTypes;
